import { FC } from 'react';
import map from 'lodash/map';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import Item from 'antd/lib/form/FormItem';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import Input from 'antd/lib/input/Input';
import InputNumber from 'antd/lib/input-number';
import Select from 'antd/lib/select';

import { SHIPPING_TIME_DATA } from 'components/Settings/dataConstants';
import { EPoliciesFields } from 'types/settings/enums';

const { Option } = Select;

interface IShippingByCountryItem {
  fieldKey: number;
}

const ShippingByCountryItem: FC<IShippingByCountryItem> = ({ fieldKey }) => (
  <Row gutter={[20, 5]} className="flex items-center">
    <Col span={5}>
      <Item name={[fieldKey, 'countryFullName']}>
        <Input bordered={false} size="large" className="disabled-only-events" />
      </Item>
    </Col>
    <Col span={5}>
      <Item name={[fieldKey, 'isAllowed']} valuePropName="checked">
        <Checkbox />
      </Item>
    </Col>
    <Col span={7}>
      <Item shouldUpdate>
        {(form, required = form.getFieldValue('shipping')[fieldKey].isAllowed) =>
          <Item
            name={[fieldKey, EPoliciesFields.ProcessingTimeId]}
            rules={[{ required, message: 'Field is required' }]}
          >
            <Select size="large" placeholder="Select Shipping Time" disabled={!required}>
              {map(SHIPPING_TIME_DATA, ({ id, description }) =>
                <Option key={id} value={id}>{description} Business Days</Option>)}
            </Select>
          </Item>}
      </Item>
    </Col>
    <Col span={7}>
      <Item shouldUpdate>
        {(form, required = form.getFieldValue('shipping')[fieldKey].isAllowed) =>
          <Item name={[fieldKey, 'price']} rules={[{ required, message: 'Field is required' }]}>
            <InputNumber
              min={0}
              size="large"
              maxLength={6}
              className="w-full"
              placeholder="Enter Shipping Price"
              disabled={!required}
            />
          </Item>}
      </Item>
    </Col>
  </Row>
);

export default ShippingByCountryItem;
